const ROOT = 'AGENCY_CONTRACT_V2_VIEW_';

const actionTypes = {
  LOAD_CONTRACT_REQUEST: `${ROOT}LOAD_CONTRACT_REQUEST`,
  LOAD_CONTRACT_SUCCESS: `${ROOT}LOAD_CONTRACT_SUCCESS`,
  LOAD_CONTRACT_LEGACY: `${ROOT}LOAD_CONTRACT_LEGACY`,
  LOAD_CONTRACT_ERROR: `${ROOT}LOAD_CONTRACT_ERROR`,
  SEED_CONTRACT: `${ROOT}SEED_CONTRACT`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actionTypes;
